import SuppliersConstants from '@/store/modules/usersManagement/suppliers/constants';
import UsersService from '@/services/usersService';

const usersService = new UsersService();

export default {
  [SuppliersConstants.actionTypes.loadSuppliers]({
    commit,
    state,
  }) {
    const {
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
    } = state.paginationInfo;
    const {
      filterQuery,
    } = state;

    commit(SuppliersConstants.mutationTypes.setIsLoading, true);
    usersService
      .getSuppliers({
        pageNumber,
        pageSize,
        sortBy,
        sortOrder,
        filterQuery,
      })
      .then((apiResponse) => {
        if (apiResponse) {
          if (apiResponse === null) {
            commit(SuppliersConstants.mutationTypes.setSuppliers, []);
            commit(SuppliersConstants.mutationTypes.setSuppliersTotal, 0);
          } else {
            commit(SuppliersConstants.mutationTypes.setSuppliers, apiResponse.items);
            commit(SuppliersConstants.mutationTypes.setSuppliersTotal, apiResponse.total);
          }
          commit(SuppliersConstants.mutationTypes.setIsLoading, false);
        }
      })
      .catch(() => {
        commit(SuppliersConstants.mutationTypes.setSuppliers, []);
        commit(SuppliersConstants.mutationTypes.setSuppliersTotal, 0);
        commit(SuppliersConstants.mutationTypes.setIsLoading, false);
      });
  },

  [SuppliersConstants.actionTypes.updatePaginationInfo]({
    commit,
    dispatch,
  }, paginationInfo) {
    commit(SuppliersConstants.mutationTypes.setPaginationInfo, paginationInfo);

    dispatch(SuppliersConstants.actionTypes.loadSuppliers);
  },

  [SuppliersConstants.actionTypes.onFilterQueryChanged]({
    commit,
    dispatch,
  }, newValue) {
    commit(SuppliersConstants.mutationTypes.setFilterQuery, newValue);
    commit(SuppliersConstants.mutationTypes.setPaginationInfoPageNumber, 1);

    dispatch(SuppliersConstants.actionTypes.loadSuppliers);
  },

  [SuppliersConstants.actionTypes.addNewSupplier]({
    commit,
    dispatch,
  }, newSupplier) {
    return usersService
      .addSupplier(newSupplier)
      .then((data) => {
        commit(SuppliersConstants.mutationTypes.setIsLoading, true);

        dispatch(SuppliersConstants.actionTypes.loadSuppliers);

        return Promise.resolve(data);
      })
      .catch((err) => Promise.reject(err));
  },

  [SuppliersConstants.actionTypes.updateSupplier]({
    commit,
    dispatch,
  }, supplier) {
    return usersService
      .updateSupplier(supplier)
      .then((data) => {
        commit(SuppliersConstants.mutationTypes.setIsLoading, true);

        dispatch(SuppliersConstants.actionTypes.loadSuppliers);

        return Promise.resolve(data);
      })
      .catch((err) => Promise.reject(err));
  },

  [SuppliersConstants.actionTypes.resendEmailVerification](vuexObj, supplierInfo) {
    return usersService
      .resendSupplierEmailVerification(supplierInfo)
      .then((data) => Promise.resolve(data))
      .catch((err) => Promise.reject(err));
  },
};
